/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react/macro';
import cx from 'classnames';
import { ReactNode } from 'react';

import { useStyles } from 'utils/useStyles';

import { Text, TextProps } from './Text';

const getStyles = () => css`
  margin: 0.8rem 0 0;
`;

export interface HintTextProps {
  children: ReactNode;

  align?: TextProps['align'];
  className?: string;
  id?: string;
}

export const HintText = ({ children, align, className, id }: HintTextProps) => {
  const styles = useStyles(getStyles);

  return (
    <Text align={align} className={cx('hint-text', className)} css={styles} id={id} type="tiny">
      {children}
    </Text>
  );
};
